import { render, staticRenderFns } from "./ParceriaSodexo.vue?vue&type=template&id=70db8ed2&"
import script from "./ParceriaSodexo.vue?vue&type=script&lang=js&"
export * from "./ParceriaSodexo.vue?vue&type=script&lang=js&"
import style0 from "./ParceriaSodexo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports